/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Switch from 'components/atoms/switch';
import Checkbox from 'components/atoms/checkbox';
import MonitoringPushModal from 'components/atoms/monitoring_push_modal';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { getUserContacts } from 'store/modules/user_contacts_store/actions';
import { ManagementState } from 'store/modules/management_store/types';
import {
  getManagementPreferences,
  updateManagementPreferences,
} from 'store/modules/management_store/actions';
import tabId from 'services/tabId';
import Loader from 'components/atoms/loader';
import companyId from 'services/company_id';
import { Container } from './styles';

const ManagementConfiguration = () => {
  const dispatch = useDispatch();

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const { management_preferences, request } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const isEnabled = () => {
    if ('Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window)
      return Notification.permission;

    return undefined;
  };

  const [pushEnabled] = useState<string | undefined>(isEnabled());
  const [pushNotificationModalOpened, setPushNotificationModalOpened] = useState<boolean>(false);
  const [activePreferences, setActivePreferences] = useState<boolean>(true);
  const [emailPreference, setEmailPreferences] = useState<boolean>(
    management_preferences?.email_notification || false,
  );
  const [whatsappPreference, setWhatsappPreferences] = useState<boolean>(
    management_preferences?.whatsapp_notification || false,
  );
  const [pushPreference, setPushPreferences] = useState<boolean>(
    management_preferences?.push_notification || false,
  );
  const [clarificationPreference, setClarificationPreferences] = useState<boolean>(
    management_preferences?.clarification_notification || false,
  );
  const [noticePreference, setNoticePreferences] = useState<boolean>(
    management_preferences?.notice_notification || false,
  );
  const [impugnmentPreference, setImpugnmentPreferences] = useState<boolean>(
    management_preferences?.impugnment_notification || false,
  );
  const [appealPreference, setAppealPreferences] = useState<boolean>(
    management_preferences?.appeal_notification || false,
  );
  const [statusPreference, setStatusPreferences] = useState<boolean>(
    management_preferences?.status_notification || false,
  );
  const [resultPreference, setResultPreferences] = useState<boolean>(
    management_preferences?.result_notification || false,
  );

  useEffect(() => {
    if (!management_preferences?.id) return;
    if (request?.get_management_preferences?.loading) return;
    if (
      management_preferences?.email_notification === emailPreference &&
      management_preferences?.whatsapp_notification === whatsappPreference &&
      management_preferences?.push_notification === pushPreference &&
      management_preferences?.clarification_notification === clarificationPreference &&
      management_preferences?.notice_notification === noticePreference &&
      management_preferences?.impugnment_notification === impugnmentPreference &&
      management_preferences?.appeal_notification === appealPreference &&
      management_preferences?.status_notification === statusPreference &&
      management_preferences?.result_notification === resultPreference
    )
      return;

    if (management_preferences && !emailPreference && !whatsappPreference && !pushPreference)
      setActivePreferences(false);

    dispatch(
      updateManagementPreferences(
        management_preferences?.id,
        emailPreference,
        whatsappPreference,
        pushPreference,
        clarificationPreference,
        noticePreference,
        impugnmentPreference,
        appealPreference,
        statusPreference,
        resultPreference,
      ),
    );
  }, [
    emailPreference,
    whatsappPreference,
    pushPreference,
    clarificationPreference,
    noticePreference,
    impugnmentPreference,
    appealPreference,
    statusPreference,
    resultPreference,
  ]);

  useEffect(() => {
    if (activePreferences === false) {
      setEmailPreferences(false);
      setWhatsappPreferences(false);
      setPushPreferences(false);
      setClarificationPreferences(false);
      setNoticePreferences(false);
      setImpugnmentPreferences(false);
      setAppealPreferences(false);
      setStatusPreferences(false);
      setResultPreferences(false);
    }
  }, [activePreferences]);

  useEffect(() => {
    if (!request?.get_management_preferences?.loaded) return;

    setEmailPreferences(management_preferences?.email_notification);
    setWhatsappPreferences(management_preferences?.whatsapp_notification);
    setPushPreferences(management_preferences?.push_notification);
    setClarificationPreferences(management_preferences?.clarification_notification);
    setNoticePreferences(management_preferences?.notice_notification);
    setImpugnmentPreferences(management_preferences?.impugnment_notification);
    setAppealPreferences(management_preferences?.appeal_notification);
    setStatusPreferences(management_preferences?.status_notification);
    setResultPreferences(management_preferences?.result_notification);

    if (
      management_preferences &&
      !management_preferences?.email_notification &&
      !management_preferences?.whatsapp_notification &&
      !management_preferences?.push_notification
    ) {
      setActivePreferences(false);
    }
  }, [request.get_management_preferences]);

  useEffect(() => {
    dispatch(getUserContacts(companyId(profile)));
    dispatch(
      getManagementPreferences(
        profile.representant ? profile?.currentCompany[tabId()] : profile.clientId,
      ),
    );
  }, []);

  return (
    <Container>
      <div className="page-container">
        <div className="container p-4">
          <div className="row mb-3">
            <div className="col-12">
              <Link to="/minhas_licitacoes/management">
                <i className="material-icons align-middle">keyboard_arrow_left</i> Voltar para o
                Gerenciar Licitações
              </Link>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-12">
              <h4>Configurações do Gerenciar Licitações</h4>
              <div className="card shadow">
                {request?.get_management_preferences?.loading ? (
                  <Loader />
                ) : (
                  <div className="card-body">
                    <div className="row mt-3">
                      <div className="col-12">
                        <p className="mb-1 d-flex align-items-center">
                          Notificação para Esclarecimentos, Impugnações e Avisos
                        </p>
                        <Switch
                          handleChange={() => setActivePreferences(!activePreferences)}
                          checked={activePreferences}
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-12">
                        <p className="mb-1"> Tipo de Notificação</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 d-flex align-items-center mb-1">
                        <Checkbox
                          customClass="m-0"
                          handleChange={() => setEmailPreferences(!emailPreference)}
                          label="Email"
                          checked={emailPreference}
                          disabled={!activePreferences}
                        />
                        <span
                          className="ml-1 databalloon management-help-mark d-inline-block rounded-circle bg-primary text-white"
                          data-balloon-length="large"
                          aria-label="Você receberá o email quando um novo Esclarecimentos, Impugnações ou Avisos surgir."
                          data-balloon-pos="up"
                        >
                          <i className="oi oi-question-mark" />
                        </span>
                      </div>
                      <div className="col-12 d-flex align-items-center">
                        <Checkbox
                          customClass="m-0"
                          handleChange={() => setWhatsappPreferences(!whatsappPreference)}
                          label="Whatsapp"
                          checked={whatsappPreference}
                          disabled={!activePreferences}
                        />
                        <span
                          className="ml-1 databalloon management-help-mark d-inline-block rounded-circle bg-primary text-white"
                          data-balloon-length="large"
                          aria-label="Você receberá uma mensagem no whatsapp quando um novo Esclarecimentos, Impugnações ou Avisos surgir."
                          data-balloon-pos="up"
                        >
                          <i className="oi oi-question-mark" />
                        </span>
                      </div>
                      <div className="col-12 d-flex align-items-center">
                        <Checkbox
                          customClass="m-0"
                          handleChange={() => setPushPreferences(!pushPreference)}
                          label="Notificação na área de trabalho (Push notification) "
                          checked={pushPreference}
                          disabled={!activePreferences}
                        />
                        {pushEnabled === 'granted' ? (
                          <div role="alert" className="alert alert-success p-1 m-0">
                            O push em seu navegador está ativado.
                          </div>
                        ) : (
                          <div role="alert" className="alert alert-warning p-1 m-0">
                            As notificações estão desativadas.{' '}
                            <a
                              className="p-0 alert-link"
                              data-toggle="modal"
                              data-target="#push-modal"
                              onClick={() => {
                                setPushNotificationModalOpened(true);
                              }}
                              href="#"
                            >
                              Clique para ativar.
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-12">
                        <p className="mb-1"> Receber notificações de</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 d-flex align-items-center">
                        <Checkbox
                          customClass="m-0"
                          handleChange={() => setClarificationPreferences(!clarificationPreference)}
                          label="Esclarecimento"
                          checked={clarificationPreference}
                          disabled={!activePreferences}
                        />
                        <span
                          className="ml-1 databalloon management-help-mark d-inline-block rounded-circle bg-primary text-white"
                          data-balloon-length="large"
                          aria-label="Você receberá alertas quando tiver novo Esclarecimento"
                          data-balloon-pos="up"
                        >
                          <i className="oi oi-question-mark" />
                        </span>
                      </div>
                      <div className="col-12 d-flex align-items-center">
                        <Checkbox
                          customClass="m-0"
                          handleChange={() => setNoticePreferences(!noticePreference)}
                          label="Aviso"
                          checked={noticePreference}
                          disabled={!activePreferences}
                        />
                        <span
                          className="ml-1 databalloon management-help-mark d-inline-block rounded-circle bg-primary text-white"
                          data-balloon-length="large"
                          aria-label="Você receberá alertas quando tiver novo Aviso"
                          data-balloon-pos="up"
                        >
                          <i className="oi oi-question-mark" />
                        </span>
                      </div>
                      <div className="col-12 d-flex align-items-center">
                        <Checkbox
                          customClass="m-0"
                          handleChange={() => setImpugnmentPreferences(!impugnmentPreference)}
                          label="Impugnação"
                          checked={impugnmentPreference}
                          disabled={!activePreferences}
                        />
                        <span
                          className="ml-1 databalloon management-help-mark d-inline-block rounded-circle bg-primary text-white"
                          data-balloon-length="large"
                          aria-label="Você receberá alertas quando tiver uma nova Impugnação"
                          data-balloon-pos="up"
                        >
                          <i className="oi oi-question-mark" />
                        </span>
                      </div>
                      <div className="col-12 d-flex align-items-center">
                        <Checkbox
                          customClass="m-0"
                          handleChange={() => setAppealPreferences(!appealPreference)}
                          label="Recurso"
                          checked={appealPreference}
                          disabled={!activePreferences}
                        />
                        <span
                          className="ml-1 databalloon management-help-mark d-inline-block rounded-circle bg-primary text-white"
                          data-balloon-length="large"
                          aria-label="Você receberá alertas quando tiver um novo Recurso"
                          data-balloon-pos="up"
                        >
                          <i className="oi oi-question-mark" />
                        </span>
                      </div>
                      <div className="col-12 d-flex align-items-center">
                        <Checkbox
                          customClass="m-0"
                          handleChange={() => setStatusPreferences(!statusPreference)}
                          label="Status"
                          checked={statusPreference}
                          disabled={!activePreferences}
                        />
                        <span
                          className="ml-1 databalloon management-help-mark d-inline-block rounded-circle bg-primary text-white"
                          data-balloon-length="large"
                          aria-label="Você receberá alertas quando tiver uma atualização no status"
                          data-balloon-pos="up"
                        >
                          <i className="oi oi-question-mark" />
                        </span>
                      </div>
                      <div className="col-12 d-flex align-items-center">
                        <Checkbox
                          customClass="m-0"
                          handleChange={() => setResultPreferences(!resultPreference)}
                          label="Resultados"
                          checked={resultPreference}
                          disabled={!activePreferences}
                        />
                        <span
                          className="ml-1 databalloon management-help-mark d-inline-block rounded-circle bg-primary text-white"
                          data-balloon-length="large"
                          aria-label="Você receberá alertas quando os resultados forem publicados"
                          data-balloon-pos="up"
                        >
                          <i className="oi oi-question-mark" />
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <MonitoringPushModal
        pushEnabled={pushEnabled}
        monitoringNotificationModalOpened={pushNotificationModalOpened}
        setMonitoringNotificationModalOpened={setPushNotificationModalOpened}
      />
    </Container>
  );
};
export default ManagementConfiguration;
